/**
 * Hvem en logistikklinje er for — delt mellom reise, overnatting og måltid (sak 78.1).
 *
 * ---------------------------------------------------------------------------------------------
 * ÉN EIER: EN ACT, ELLER ÅRGANGEN. ALDRI BEGGE, OG ALDRI INGEN.
 *
 * Atle, 3. september: «Det må gå an å legge til linjer her. F.eks at vi kan sette opp en transport
 * eller overnatting for noen som ikke er en act.» En festival flyr inn en lydtekniker, henter en
 * fotograf på flyplassen og bestiller crewmat. Ingen av dem er en booking, og alle tre er logistikk
 * noen må planlegge.
 *
 * IKKE BEGGE, og det er en skranke framfor en forglemmelse. En rads årgang er et FAKTUM om acten
 * den henger på, og en forespørsel som kunne navngi de to hver for seg kunne lagt en bookings fly
 * i et annet festivalår — stille, siden ingen skranke sammenligner dem. Så den som skriver
 * navngir én, og tjenesten utleder den andre.
 *
 * Migrering 0060 (reise og overnatting) og 0061 (måltider) er det som gjør det mulig i databasen.
 * De tre kontraktene importerer herfra framfor å skrive den samme skranken tre ganger — en regel
 * i tre kopier er en regel som blir ulik i to av dem.
 */
import { z } from 'zod';

/** Hvor langt «for hvem» kan bli. En etikett, ikke et notatfelt. */
export const MAX_FOR_WHOM = 160;

export const oneOwner = (body: {
  performanceId?: string | null | undefined;
  editionId?: string | null | undefined;
}): boolean => (body.performanceId == null) !== (body.editionId == null);

export const ONE_OWNER = {
  message: 'Name either the performance or the edition, not both.',
  path: ['performanceId'],
};

/**
 * «For hvem» — overskriften en rad uten act ellers ikke ville hatt.
 *
 * «Lydcrew», «fotograf NRK», «Kari fra Sirkus». Feltet finnes på ALLE rader og ikke bare på dem
 * uten act: en reise som først var «lydcrew» og siden ble hektet på en booking skal ikke miste
 * teksten sin, og en skranke som bandt de to sammen ville gjort nettopp det.
 */
export const forWhomSchema = z.string().trim().min(1).max(MAX_FOR_WHOM);
